import Plotly, { Config, Data, Layout } from 'plotly.js-dist-min'
import React from 'react'
import createPlotlyComponent from 'react-plotly.js/factory'

const Plot = createPlotlyComponent(Plotly)

interface PlotParams {
  data: Data[]
  layout?: Partial<Layout>
  config?: Partial<Config>
  style?: React.CSSProperties
  useResizeHandler?: boolean
  className?: string
}

const PlotComponent = (props: PlotParams) => {
  return (
    <Plot
      data={props.data}
      layout={props.layout || {}}
      config={props.config}
      style={props.style}
      useResizeHandler={props.useResizeHandler}
      className={props.className}
    />
  )
}

export default PlotComponent
